import { createContext, useContext, useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getById } from '@/api/organization.api.private';
import authenticationServiceApi from 'shared/api/authentication.service.api';
import AuthenticationService from '@/lib/auth';

const OrganizationContext = createContext();

export function useOrganizationContext() {
  return useContext(OrganizationContext);
}

export function OrganizationContextProvider({ children }) {
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(true);
  const [organizationId, setOrganizationId] = useState(null);
  const [organization, setOrganization] = useState(null);

  useEffect(() => {
    if (organizationId) {
      fetchData();
    }
  }, [organizationId]);

  const fetchData = async () => {
    setLoading(true);

    const { data } = await getById(organizationId);
    setOrganization(data);

    const { data: switchData } = await authenticationServiceApi.switchOrganization({
      id: organizationId,
    });
    if (switchData?.accessToken) {
      AuthenticationService.updateAccessToken(switchData.accessToken);
    }

    // Managed org/token just changed — drop org-scoped cache so queries refetch
    // for the new org instead of serving the previous org's data.
    queryClient.clear();

    setLoading(false);
  };

  const value = {
    organization,
    setOrganization,
    loading,
    setOrganizationId,
  };

  return <OrganizationContext.Provider value={value}>{children}</OrganizationContext.Provider>;
}
